import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from '../src/environments/environment';

const azureAd = environment.msalConfig;

export const msalConfig: Configuration = {
  auth: {
    clientId: azureAd.auth.clientId,
    authority: azureAd.auth.authority,
    redirectUri: azureAd.auth.redirectUri,
    postLogoutRedirectUri: azureAd.auth.postLogoutRedirectUri,
    navigateToLoginRequestUrl: azureAd.auth.navigateToLoginRequestUrl
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIEBrowser(),
  },
  system: {
    loggerOptions: {
      loggerCallback: (logLevel, message, containsPii) => {
        //console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
};

export const protectedResources = {
  api: {
    endpoint: azureAd.resources.resourceUri,
    scopes: [azureAd.resources.resourceScope],
  },
};

export const loginRequest = {
  scopes: [...azureAd.scopes.loginRequest]
};

export function isIEBrowser(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  return (
    window.navigator.userAgent.indexOf('MSIE ') > -1 ||
    window.navigator.userAgent.indexOf('Trident/') > -1
  );
}
